import React from "react"

export const FileFilledIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M17.084 8.49297H14.6757C12.7007 8.49297 11.0923 6.88463 11.0923 4.90964V2.5013C11.0923 2.04297 10.7173 1.66797 10.259 1.66797H6.72565C4.15898 1.66797 2.08398 3.33464 2.08398 6.30964V13.693C2.08398 16.668 4.15898 18.3346 6.72565 18.3346H13.2757C15.8423 18.3346 17.9173 16.668 17.9173 13.693V9.3263C17.9173 8.86797 17.5423 8.49297 17.084 8.49297Z"
            fill="#02C2A6"
        />
        <path
            d="M13.1667 1.84207C12.8251 1.5004 12.2334 1.73373 12.2334 2.20873V5.11707C12.2334 6.33373 13.2667 7.34207 14.5251 7.34207C15.3167 7.3504 16.4167 7.3504 17.3584 7.3504C17.8334 7.3504 18.0834 6.79207 17.7501 6.45873C16.5501 5.2504 14.4001 3.0754 13.1667 1.84207Z"
            fill="#02C2A6"
        />
    </svg>
)
